import { Container, Grid, Paper, Typography, Box } from '@mui/material'
import { motion } from 'framer-motion'

const MotionPaper = motion(Paper)

const features = [
  {
    title: 'Generativní AI Design',
    items: [
      'Automatizované generování návrhů produktů',
      'Optimalizace designu s ohledem na výrobní omezení',
      'Validace návrhů pomocí simulací',
    ],
  },
  {
    title: 'Optimalizace výroby',
    items: [
      'Analýza výrobních dat v reálném čase',
      'Prediktivní údržba zařízení',
      'Optimalizace využití zdrojů a energetické účinnosti',
    ],
  },
  {
    title: 'Systémová integrace',
    items: [
      'Napojení na existující průmyslové systémy (ERP, MES, PLM)',
      'API rozhraní pro rozšiřitelnost',
      'Podpora standardních průmyslových protokolů',
    ],
  },
  {
    title: 'Měřitelné přínosy',
    items: [
      'Snížení času vývoje nových produktů o 40%',
      'Redukce výrobních nákladů o 30%',
      'Zvýšení efektivity využití zdrojů o 25%',
    ],
  },
  {
    title: 'Bezpečnost',
    items: [
      'ISO 27001 certifikace',
      'GDPR compliance',
      'Průmyslové bezpečnostní standardy',
    ],
  },
  {
    title: 'Technické specifikace',
    items: [
      'Cloudová architektura',
      'Modulární design',
      'Škálovatelnost pro různé velikosti výroby',
    ],
  },
]

export default function Features() {
  return (
    <Container>
      <Box sx={{ my: 4 }}>
        <Typography variant="h2" gutterBottom align="center">
          Funkce a možnosti
        </Typography>
        <Typography variant="h5" align="center" color="text.secondary" paragraph>
          Komplexní řešení pro průmyslovou optimalizaci
        </Typography>

        <Grid container spacing={4} sx={{ mt: 4 }}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <MotionPaper
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                elevation={2}
                sx={{ p: 3, height: '100%' }}
              >
                <Typography variant="h5" gutterBottom color="primary">
                  {feature.title}
                </Typography>
                <Box component="ul" sx={{ pl: 2 }}>
                  {feature.items.map((item, itemIndex) => (
                    <Box
                      component="li"
                      key={itemIndex}
                      sx={{ mb: 1 }}
                    >
                      <Typography variant="body1">
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </MotionPaper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  )
} 